/**
 * Category → professional lucide icon map, shared by the Served card, the wall filters
 * and anywhere a case category is labelled. React icons only — never emoji.
 */
import { Home, ShoppingBasket, HeartPulse, HandHeart } from 'lucide-react';

export const CATEGORY_ICON = {
  housing: Home,
  ration: ShoppingBasket,
  medical: HeartPulse,
  other: HandHeart,
};

/** Resolve an icon component for a category, with a safe default. */
export function categoryIcon(category) {
  return CATEGORY_ICON[category] || HandHeart;
}

export default CATEGORY_ICON;
